import DefaultUnitPriceCalculator from "./DefaultUnitPriceCalculator";

export default class DefaultUnitPriceCalculatorFactory {
    private static readonly INSTANCE = new DefaultUnitPriceCalculator();
    public static getInstance() {
        return this.INSTANCE;
    }
}
